// Headless export registration for the Matrix family. One MatrixChart component serves
// all 7 legacy dispatch keys (mx/sr/se/ps/mp/ro/aro) — registered once via registerHc.
// MatrixChart renders through ChartContainer, so the Phase 2 hook attachment already
// makes it exportable; this file only maps the payload to props.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03-highcharts-rollout.md §4.2

import { commonHcProps, registerHc } from '@aytm/app/stats/page/question-views/components/charts/lib/hc-exportable'
import { withWordCloudMode } from '@aytm/app/stats/page/question-views/components/word-cloud/wordCloudMode'

import MatrixChart from '@aytm/app/stats/page/question-views/mx/components/chart/Chart'
import { getDefaultChartView } from '@aytm/app/stats/page/question-views/components/controls/lib/view-modes'
import { calcViewModes } from '@aytm/app/stats/page/question-views/mx/states/useMatrixBlock'

// Legacy delegates a matrix in chartMode 'wc' to the open-ended params — the summary /
// multi-batch matrix draws its batches as a cloud, same as the answer-variant families.
const MatrixDispatcher = withWordCloudMode(MatrixChart, 'MatrixDispatcher')

registerHc(['mx', 'sr', 'se', 'ps', 'mp', 'ro', 'aro'], MatrixDispatcher, (data: any, params: any) => ({
  ...commonHcProps(data, params),
  // view-selection from controls → params
  // a report that never picked a view opens on the type's own default, as the block does: for a
  // polarity scale that is its only view, the score average, not the stacked default the rest share
  viewMode: params.viewMode || getDefaultChartView(calcViewModes(data.qType, data.subType, data.format)),
  topsMode: params.topsMode,
  labelsMode: params.labelsMode,
  // question/scale config → data
  rType: data.rType,
  degree: data.degree,
  maxAnswerPosition: data.maxAnswerPosition,
  trait: data.trait,
  // headless: hide the interactive view-options control
  viewOptionsDisabled: true,
  // chartMode 'wc' draws the matrix batches as a word cloud instead of a chart.
  questionId: data.questionId,
  answerVariants: data.answerVariants,
  wcConfig: params.wcConfig,
  wcWidth: params.width,
  wcHeight: params.height
}))
